/**
 * A comma nobody sees, between two things the layout has already separated.
 *
 * A line break is not punctuation. The sensor readouts stack their parts on separate lines —
 * latitude above longitude above the accuracy figure, a cardinal point beside a bearing — and the
 * text still flows as one string, so a reader ran them together: "Latitude 51.5074 Longitude minus
 * 0.1278" made "south" sound like part of the longitude, and the accuracy arrived with no pause at
 * all. The comma has to be IN the text to produce the pause, and it must not be on screen, where
 * the values are already separated.
 *
 * A literal rather than a translated string: this is punctuation for a speech synthesiser, and
 * every locale this app ships uses a comma for exactly this. It is deliberately not an
 * `aria-label` on the parent either — that would replace the value's own text, including the
 * formatting each block worked out.
 */
export const SpokenPause = () => <span className='sr-only'>, </span>;
